/**
 * useWaitlist — the coming-soon email capture, shared by both looks
 * (MainPage.js renders both since v1.71; Floodlight only retypes it).
 * Moved verbatim from MainPage.js (v1.70): no request while empty or already
 * sending, trims the address, clears it on success, toasts the error.
 */
import { useState } from 'react';
import { joinWaitlist } from '../services/launchService';
import { showToast } from '../utils/toast';

export const WAITLIST_SOURCE = 'coming_soon';
export const WAITLIST_ERROR = 'Could not join the waitlist. Try again.';

export default function useWaitlist(source = WAITLIST_SOURCE) {
  const [email, setEmail] = useState('');
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const onNotify = async () => {
    if (!email || sending) return;
    try {
      setSending(true);
      await joinWaitlist(email.trim(), source);
      setSent(true);
      setEmail('');
    } catch (e) {
      showToast(e?.message || WAITLIST_ERROR, 'error');
    } finally {
      setSending(false);
    }
  };

  return { email, setEmail, sending, sent, onNotify };
}
